import { toast, type TypeOptions } from "react-toastify";

/**
 * Toast: confirmação efêmera, no canto inferior direito.
 *
 * `info` existe porque nem todo aviso é um erro. Faltar o período antes de
 * gerar a planilha não é falha nenhuma — é uma etapa que ainda não foi feita, e
 * anunciá-la em vermelho faz o usuário achar que quebrou alguma coisa. Vermelho
 * é para o que deu errado de fato; o resto é informação.
 *
 * Aviso que precisa continuar na tela enquanto a condição existir não é toast:
 * é o `Alert` do Design System.
 */
type ToastType = "success" | "error" | "info";

export const useToast = () => {
  const showToast = (message: string, type: ToastType) =>
    toast(message, {
      position: "bottom-right",
      autoClose: 3000,
      theme: "light",
      type: type satisfies TypeOptions,
    });

  return {
    showToast,
  };
};
